<template>
  <div class="block_wrap">

    <div class="line">
      <div class="input_wrap">
        <label> {{ translate('user.client') }} </label>
        <sis-select
            :options="clients_list"
            v-model="upd_user.client_id"
            :placeholder="translate('user.client')"
            :searchable="false"
            :multiple="false"
            :close_on_select="false"
            :hide_selected="true"
            :preserveSearch="true"
            :clearable="false"
            :max_height="165"
            :disabled="check_client_id"
        />
      </div>
    </div>

    <div class="line">
      <div class="input_wrap">
        <fg-input
          v-model="upd_user.name"
          type="text"
          :label="translate('user.name')"
          :placeholder="translate('user.name')"
        />
      </div>

      <div class="input_wrap main_name">
        <fg-input
          v-model="upd_user.username"
          type="text"
          :label="translate('user.login')"
          :placeholder="translate('user.login')"
        />
      </div>

      <div class="filter checkbox">
        <div class="info">
          {{ active_user ? translate('user.active') : translate('user.blocked')}}
        </div>
        <label class="switch" @click.prevent="active_user = !active_user">
          <input type="checkbox" v-model="active_user">
          <span class="slider round"></span>
        </label>
      </div>
    </div>

    <div class="line">
      <div class="input_wrap">
        <fg-input
          v-model="upd_user.email"
          type="email"
          label="Email"
          placeholder="Email"
        />
      </div>

      <div class="input_wrap">
        <fg-input
          autocomplete="sdfgsdfgsfhsdfgsdfh"
          v-model="upd_user.phone"
          :type="'tel'"
          :label="translate('user.phone')"
          onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
          :placeholder="translate('user.phone')"
          :name="'asdgasdfasgd'"
        />
      </div>

    </div>

    <div class="update_password">
      <fg-input
          name="npu"
          autocomplete="off"
          v-model="upd_user.password"
          type="text"
          :label="translate('user.password.one')"
          :placeholder="translate('user.password.one')"
      />
      <fg-input
          name="npu"
          autocomplete="off"
          v-model="upd_user.conf_password"
          type="text"
          :label="translate('user.password.confirm')"
          :placeholder="translate('user.password.confirm')"
      />
      <div class="form-group">
        <button
            type="submit"
            class="btn btn-info btn-fill cstm-lg-mt-26 cstm-sm-mb-26"
            @click.prevent="generate"
        >
          {{ translate('user.password.generate') }}
        </button>
      </div>
    </div>

    <div class="line" v-if="changes">
      <div class="button_wrap">
        <button
          class="btn btn-success btn-fill btn-wd"
          @click.prevent="update_profile"
        >
          save
        </button>
      </div>
    </div>

  </div>
</template>
<script>

export default {
  name: 'UserMainInfo',
  props: ['main_info', 'client_ids'],

  data () {
    return {
      upd_user: {},
      active_user: true
    }
  },
  computed:{
    changes(){
      let main_info = Object.assign({}, this.main_info)
      let upd_user = Object.assign({}, this.upd_user)

      delete(main_info.ts_update)
      delete(upd_user.ts_update)

      return JSON.stringify(main_info) !== JSON.stringify(upd_user)
    },
    title_filter(){
      return this.active_user ? 'user.active' : 'user.blocked'
    },
    clients_list(){
      let list = []
      for (let item of Object.entries(this.client_ids)) {
        list.push({label: item[1], id: +item[0]})
      }
      return list
    },
    check_client_id(){
      return this.main_info.client_id !== null
    }
  },
  created() {
    this.upd_user = {...this.main_info}

    if (this.upd_user.client_id === ''){
      this.upd_user.client_id = null
    }

    this.active_user = this.upd_user.active === 1
  },
  watch:{
    active_user(){
      this.upd_user.active = this.active_user ? 1 : 0
    },
    main_info(){
      this.upd_user = {...this.main_info}
    }
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    randomPassword (length) {
      let chars = 'abcdefghjkmnpqrstuvwxyzABCDEFGHJKLMNP23456789'
      let pass = ''
      let i
      for (let x = 0; x < length; x++) {
        i = Math.floor(Math.random() * chars.length)
        pass += chars.charAt(i)
      }
      return pass
    },

    generate () {
      this.$set(this.upd_user, 'password', this.randomPassword(8))
      this.upd_user.conf_password = this.upd_user.password
    },

    update_profile () {
      if (this.upd_user.id === undefined) {
        if (this.upd_user.password === '' || this.upd_user.password === undefined) {
          this.global_notify('danger', this.translate('user.password.need'))
          return
        }
      }

      if (this.upd_user.name === '' || this.upd_user.name === undefined) {
        this.global_notify('danger', this.translate('user.field.username'))
        return
      }

      if (this.upd_user.username === '' || this.upd_user.username === undefined) {
        this.global_notify('danger', this.translate('user.field.login'))
        return
      }

      if (this.upd_user.password !== this.upd_user.conf_password) {
        this.global_notify('danger', this.translate('user.password.not_match'))
        return
      }

      this.upd_user.client_id = this.upd_user.client_id === '' ? null : this.upd_user.client_id

      this.disabled_btn = true

      this.$http.v1.saveUser(this.upd_user, (response) => {
        if (response.data.code === 409) {
          this.global_notify('danger', this.translate('user.saved_error'))
          this.disabled_btn = false
        }else{
          this.global_notify('info', this.translate('user.saved'))
          this.$emit('update_user', response.data)
          this.$emit('update')
          this.$emit('close')
        }
      })
    },
  }
}

</script>

<style lang='scss' scoped>
  .block_wrap{
    text-align: left;
    .line{
      display: flex;
      justify-content: space-between;
      text-align: left;
      &.new_group{
        margin-bottom: 10px;
        .filter{
          display: contents;
        }
      }
      .input_wrap{
        width: 100%;
        margin: 0 5px;
      }
      .text_wrap{
        width: 100%;
        .input_text {
          width: 100%;
          resize: none;
          outline: none;
          background-color: #fffcf5;
          border-radius: 4px;
          color: #66615b;
          font-size: 14px;
          transition: background-color 0.3s ease 0s;
          padding: 7px 18px;
          height: 100px;
          box-shadow: none;
          border: 1px solid #e8e8e8;
        }
      }
      .button_wrap{
        width: 100%;
        text-align: right;
      }
    }
    .update_password{
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin-bottom: 15px;
      .form-group{
        width: 100%;
        margin: 0 5px;
        .btn{
          height: 40px;
          width: 100%;
          margin: 0;
        }
      }
    }
  }


</style>
